import { Component, input, output } from '@angular/core';
import { BreadcrumbItem } from '../../models';

@Component({
  selector: 'app-breadcrumb-home',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: true,
  imports: []
})
export class BreadcrumbHomeComponent {
  breadcrumbItems = input.required<BreadcrumbItem[]>();
  breadcrumbClick = output<number>();

  trackByFn(index: number, item: BreadcrumbItem): string {
    return item.label + index;
  }

  onBreadcrumbItemClick(index: number): void {
    this.breadcrumbClick.emit(index);
  }
}